export const COLLECTION_DETAILS_FORM_ID = Symbol();
export const COLLECTION_CREATE_FORM_ID = Symbol();
